import { GppBadOutlined } from "@mui/icons-material";
import { Tooltip } from "@mui/material";

export function ExploitIcon() {
  return (
    <Tooltip title="Exploitable" placement="top" arrow>
      <GppBadOutlined sx={{ color: "text.warning" }} />
    </Tooltip>
  );
}
